// extracted by mini-css-extract-plugin
export default {"row":"row__4c1d5658","label":"label__4c1d5658"};